import type { Dialog as PrimeDialog } from "primereact/dialog";
import type { ForwardedRef } from "react";

import { withDefaults } from "../../utils/with-defaults";
import { DIALOG_DEFAULTS } from "./dialog.constants";
import type { DialogProps, DialogViewModel } from "./types-dialog";

/** ViewModel do Dialog: padrões do Figma sob as props da tela e o bloqueio (`locked`): sem X, Esc nem máscara; sem JSX. */
export function useDialog(
  { size = "md", locked = false, onHide, ...props }: DialogProps,
  ref: ForwardedRef<PrimeDialog>,
): DialogViewModel {
  return {
    dialogRef: ref,
    dialogProps: {
      ...withDefaults(DIALOG_DEFAULTS, props),
      ...(locked ? { closable: false, closeOnEscape: false } : null),
      // Qualquer caminho de fechamento (X, Esc, máscara) passa por aqui.
      onHide: () => {
        if (!locked) onHide();
      },
      "data-size": size,
    },
  };
}
